import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function Marketareaindia() {
  useEffect(() => {
    // CSS to apply only on this page
    const style = document.createElement("style");
    style.innerHTML = `
      .tabs h3, .cntry{font-size:18px; word-spacing:-2px; color:#f99d1b;}
      .state-list, .city-list { display: flex; flex-wrap: wrap; padding:0; }
      .state-list li,.navlist,.city-list li {
          width: 19%;
          list-style-type: none;
          margin: 5px;
          background: #e04495;
          font-size: 12px;
          font-weight: 600;
          border-radius: 4px;
          box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
      }
      .navlist a,.state-list a,.city-list a{
        width:100%;
        display:inline-block;
        color:#fff;
        padding:8px 16px;
      }
      .portfolio .portfolio-item { margin-bottom: 30px; }
      .portfolio_header,.state_name {
          background: #f99d1b;
          margin-bottom: 10px;
      }
      .portfolio_header p,.state_name p{margin-bottom:0; padding:5px;}
      .portfolio #portfolio-flters {
          padding: 0;
          list-style: none;
          width: 100%;
          display: flex;
          flex-wrap: wrap;
      }
      .portfolio #portfolio-flters li {
          cursor: pointer;
          display: inline-block;
          padding: 8px 15px 10px 15px;
          font-size: 14px;
          font-weight: 600;
          line-height: 1;
          text-transform: uppercase;
          color: #444444;
          margin-bottom: 5px;
          transition: all 0.3s ease-in-out;
          border-radius: 3px;
          flex: 0 0 20%;
          display: flex;
      }
      .portfolio #portfolio-flters li:hover,
      .portfolio #portfolio-flters li.filter-active {
        color: #fff;
        background: #f99d1b;
      }
      .navlist .active { background-color: #f99d1b; width:100%; }
      .portfolio #portfolio-flters li:last-child { margin-right: 0; }
      .portfolio .portfolio-wrap {
        transition: 0.3s;
        position: relative;
        overflow: hidden;
        z-index: 1;
        background: rgba(60, 65, 51, 0.6);
      }
      .portfolio .portfolio-wrap::before {
        content: "";
        background: rgba(60, 65, 51, 0.6);
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        transition: all ease-in-out 0.3s;
        z-index: 2;
        opacity: 0;
      }
      .portfolio .portfolio-wrap img {
        transition: all ease-in-out 0.3s;
      }
      .portfolio .portfolio-wrap .portfolio-info {
        opacity: 0;
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        z-index: 3;
        transition: all ease-in-out 0.3s;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;
      }
      .portfolio .portfolio-wrap .portfolio-info h4 {
        font-size: 20px;
        color: #fff;
        font-weight: 600;
      }
      .portfolio .portfolio-wrap .portfolio-info p {
        color: rgba(255, 255, 255, 0.7);
        font-size: 14px;
        text-transform: uppercase;
        padding: 0;
        margin: 0;
        font-style: italic;
      }
      .portfolio .portfolio-wrap .portfolio-links {
        text-align: center;
        z-index: 4;
      }
      .portfolio .portfolio-wrap .portfolio-links a {
        color: #fff;
        margin: 0 5px 0 0;
        font-size: 28px;
        display: inline-block;
        transition: 0.3s;
      }
      .portfolio .portfolio-wrap .portfolio-links a:hover {
        color: #c0da91;
      }
      .portfolio .portfolio-wrap:hover::before { opacity: 1; }
      .portfolio .portfolio-wrap:hover img { transform: scale(1.2); }
      .portfolio .portfolio-wrap:hover .portfolio-info { opacity: 1; }
      .portfolio-details { padding-top: 40px; }
      .portfolio-details .portfolio-details-slider img { width: 100%; }
      .portfolio-details .portfolio-details-slider .swiper-pagination {
        margin-top: 20px;
        position: relative;
      }
      .portfolio-details .portfolio-details-slider .swiper-pagination .swiper-pagination-bullet {
        width: 12px; height: 12px;
        background-color: #fff;
        opacity: 1;
        border: 1px solid #f99d1b;
      }
      .portfolio-details .portfolio-details-slider .swiper-pagination .swiper-pagination-bullet-active {
        background-color: #f99d1b;
      }
      .portfolio-details .portfolio-info {
        padding: 30px;
        box-shadow: 0px 0 30px rgba(60, 65, 51, 0.08);
      }
      .portfolio-details .portfolio-info h3 {
        font-size: 22px;
        font-weight: 700;
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #eee;
      }
      .portfolio-details .portfolio-info ul {
        list-style: none;
        padding: 0;
        font-size: 15px;
      }
      .portfolio-details .portfolio-info ul li+li { margin-top: 10px; }
      .portfolio-details .portfolio-description { padding-top: 30px; }
      .portfolio-details .portfolio-description h2 {
        font-size: 26px;
        font-weight: 700;
        margin-bottom: 20px;
      }
      .portfolio-details .portfolio-description p { padding: 0; }
    `;
    document.head.appendChild(style);

    // Remove CSS when component unmounts
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div>
        <div id="colorlib-main">
             <section className="ftco-section ftco-no-pt ftco-no-pb">
               <div className="row d-flex">
                 <div className="col-lg-12 sidebar bg-light pt-5">
                  <div className="p-3">
<h2>All Blog Locations</h2>
             
            <section id="portfolio" class="portfolio">
        <div class="tab-content mt-3">
          <div id="Arica" class=" portfolio container">
            {/* <h2>Available Locations</h2> */}
            <ul className="state-list">
              <li>
                <Link to="/blog/bengaluru">Bengaluru</Link>
              </li>
              <li>
                <Link to="/blog/hyderabad">Hyderabad</Link>
              </li>
              <li>
                <Link to="/blog/patna">Patna</Link>
              </li>
              <li>
                <Link to="/blog/lucknow">Lucknow</Link>
              </li>
              <li>
                <Link to="/blog/chennai">Chennai</Link>
              </li>
              <li>
                <Link to="/blog/mumbai">Mumbai</Link>
              </li>
              <li>
                <Link to="/blog/pune">Pune</Link>
              </li>
              <li>
                <Link to="/blog/jaipur">Jaipur</Link>
              </li>
              <li>
                <Link to="/blog/indore">Indore</Link>
              </li>
              <li>
                <Link to="/blog/agra">Agra</Link>
              </li>
              <li>
                <Link to="/blog/kolkata">Kolkata</Link>
              </li>
              <li>
                <Link to="/blog/guwahati">Guwahati</Link>
              </li>
              <li>
                <Link to="/blog/ahmedabad">Ahmedabad</Link>
              </li>
              <li>
                <Link to="/blog/noida">Noida</Link>
              </li>
              <li>
                <Link to="/blog/nagpur">Nagpur</Link>
              </li>
              <li>
                <Link to="/blog/bhopal">Bhopal</Link>
              </li>
              <li>
                <Link to="/blog/ludhiana">Ludhiana</Link>
              </li>
              <li>
                <Link to="/blog/bhubaneswar">Bhubaneswar</Link>
              </li>
              <li>
                <Link to="/blog/coimbatore">Coimbatore</Link>
              </li>
              <li>
                <Link to="/blog/ghaziabad">Ghaziabad</Link>
              </li>
              <li>
                <Link to="/blog/gurugram">Gurugram</Link>
              </li>
              <li>
                <Link to="/blog/kanpur">Kanpur</Link>
              </li>
              <li>
                <Link to="/blog/faridabad">Faridabad</Link>
              </li>
              <li>
                <Link to="/blog/varanasi">Varanasi</Link>
              </li>
              <li>
                <Link to="/blog/gorakhpur">Gorakhpur</Link>
              </li>
              <li>
                <Link to="/blog/sonipat">Sonipat</Link>
              </li>
              <li>
                <Link to="/blog/ranchi">Ranchi</Link>
              </li>
              <li>
                <Link to="/blog/siliguri">Siliguri</Link>
              </li>
              <li>
                <Link to="/blog/jammu">Jammu</Link>
              </li>
              <li>
                <Link to="/blog/nashik">Nashik</Link>
              </li>
              <li>
                <Link to="/blog/prayagraj">Prayagraj</Link>
              </li>
              <li>
                <Link to="/blog/mysuru">Mysuru</Link>
              </li>
              <li>
                <Link to="/blog/jodhpur">Jodhpur</Link>
              </li>
              <li>
                <Link to="/blog/aligarh">Aligarh</Link>
              </li>
              <li>
                <Link to="/blog/gwalior">Gwalior</Link>
              </li>
              <li>
                <Link to="/blog/ahmadabad">Ahmadabad</Link>
              </li>
              <li>
                <Link to="/blog/meerut">Meerut</Link>
              </li>
              <li>
                <Link to="/blog/visakhapatnam">Visakhapatnam</Link>
              </li>
              <li>
                <Link to="/blog/dehradun">Dehradun</Link>
              </li>
              <li>
                <Link to="/blog/kota">Kota</Link>
              </li>
              <li>
                <Link to="/blog/shimla">Shimla</Link>
              </li>
              <li>
                <Link to="/blog/alwar">Alwar</Link>
              </li>
              <li>
                <Link to="/blog/surat">Surat</Link>
              </li>
              <li>
                <Link to="/blog/durgapur">Durgapur</Link>
              </li>
              <li>
                <Link to="/blog/chhatrapati-sambhajinagar">
                  Chhatrapati Sambhajinagar
                </Link>
              </li>
              <li>
                <Link to="/blog/madurai">Madurai</Link>
              </li>
              <li>
                <Link to="/blog/amritsar">Amritsar</Link>
              </li>
              <li>
                <Link to="/blog/mathura">Mathura</Link>
              </li>
              <li>
                <Link to="/blog/panipat">Panipat</Link>
              </li>
              <li>
                <Link to="/blog/kochi">Kochi</Link>
              </li>
              <li>
                <Link to="/blog/srinagar">Srinagar</Link>
              </li>
              <li>
                <Link to="/blog/greater-noida">Greater Noida</Link>
              </li>
              <li>
                <Link to="/blog/sahibzada-ajit-singh-nagar">
                  Sahibzada Ajit Singh Nagar
                </Link>
              </li>
              <li>
                <Link to="/blog/bareilly">Bareilly</Link>
              </li>
              <li>
                <Link to="/blog/guntur">Guntur</Link>
              </li>
              <li>
                <Link to="/blog/tiruchirappalli">Tiruchirappalli</Link>
              </li>
              <li>
                <Link to="/blog/raipur">Raipur</Link>
              </li>
              <li>
                <Link to="/blog/thiruvananthapuram">Thiruvananthapuram</Link>
              </li>
              <li>
                <Link to="/blog/rohtak">Rohtak</Link>
              </li>
              <li>
                <Link to="/blog/udaipur">Udaipur</Link>
              </li>
              <li>
                <Link to="/blog/rajkot">Rajkot</Link>
              </li>
              <li>
                <Link to="/blog/kolhapur">Kolhapur</Link>
              </li>
              <li>
                <Link to="/blog/dhanbad">Dhanbad</Link>
              </li>
              <li>
                <Link to="/blog/vadodara">Vadodara</Link>
              </li>
              <li>
                <Link to="/blog/karnataka">Karnataka</Link>
              </li>
              <li>
                <Link to="/blog/telangana">Telangana</Link>
              </li>
              <li>
                <Link to="/blog/bihar">Bihar</Link>
              </li>
              <li>
                <Link to="/blog/uttar-pradesh">Uttar Pradesh</Link>
              </li>
              <li>
                <Link to="/blog/tamil-nadu">Tamil Nadu</Link>
              </li>
              <li>
                <Link to="/blog/maharashtra">Maharashtra</Link>
              </li>
              <li>
                <Link to="/blog/rajasthan">Rajasthan</Link>
              </li>
              <li>
                <Link to="/blog/madhya-pradesh">Madhya Pradesh</Link>
              </li>
              <li>
                <Link to="/blog/west-bengal">West Bengal</Link>
              </li>
              <li>
                <Link to="/blog/assam">Assam</Link>
              </li>
              <li>
                <Link to="/blog/gujarat">Gujarat</Link>
              </li>
              <li>
                <Link to="/blog/punjab">Punjab</Link>
              </li>
              <li>
                <Link to="/blog/odisha">Odisha</Link>
              </li>
              <li>
                <Link to="/blog/haryana">Haryana</Link>
              </li>
              <li>
                <Link to="/blog/jharkhand">Jharkhand</Link>
              </li>
              <li>
                <Link to="/blog/jammu-and-kashmir">Jammu and Kashmir</Link>
              </li>
              <li>
                <Link to="/blog/andhra-pradesh">Andhra Pradesh</Link>
              </li>
              <li>
                <Link to="/blog/uttarakhand">Uttarakhand</Link>
              </li>
              <li>
                <Link to="/blog/himachal-pradesh">Himachal Pradesh</Link>
              </li>
              <li>
                <Link to="/blog/kerala">Kerala</Link>
              </li>
              <li>
                <Link to="/blog/chhattisgarh">Chhattisgarh</Link>
              </li>
              <li>
                <Link to="/blog/tripura">Tripura</Link>
              </li>
              <li>
                <Link to="/blog/manipur">Manipur</Link>
              </li>
              <li>
                <Link to="/blog/nagaland">Nagaland</Link>
              </li>
              <li>
                <Link to="/blog/goa">Goa</Link>
              </li>
              <li>
                <Link to="/blog/meghalaya">Meghalaya</Link>
              </li>
              <li>
                <Link to="/blog/mizoram">Mizoram</Link>
              </li>
              <li>
                <Link to="/blog/sikkim">Sikkim</Link>
              </li>
              <li>
                <Link to="/blog/selangor">Selangor</Link>
              </li>
              <li>
                <Link to="/blog/johor">Johor</Link>
              </li>
              <li>
                <Link to="/blog/sabah">Sabah</Link>
              </li>
            </ul>
          </div>
        </div>
      </section>
                 </div>  </div>
               </div>
             </section>
           </div>
    
    </div>
  );



  
}



export default Marketareaindia;
